import React from 'react';

const Delivery = () => {
    return (
        <div>
            
        </div>
    );
};

export default Delivery;